import React, { ReactElement, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BsCheck, BsThreeDots } from 'react-icons/bs';
import { LiveProps } from '../../LiveContainer';
import { actions } from '../../liveSlice';
import { VoiceGuestRemoveModal } from './VoiceGuestRemoveModal';
import { VoicePairSettingModal } from './VoicePairSettingModal';
import circleNotAcceptPair from '../../../../assets/svg/bosyuu2_frame.svg';
import circleAcceptPair from '../../../../assets/svg/bosyuu1_frame.svg';
import removePairImage from '../../../../assets/svg/taisyutu.svg';

import './VoiceGuestModal.scss';
import {
  useCancelRequestPairMutation,
  useChoicePairMutation,
  useRemovePairMutation,
  useSendRequestPairMutation,
} from '../../../../services/api/apiProvider';
import { ImageCustom } from '../../../../common/components/ImageCustom';

export const VoiceGuestModal = (props: LiveProps): ReactElement => {
  const [isAllowChoice, setIsAllowChoice] = useState(false);
  const [selectedAudient, setSelectedAudient] = useState('');
  const [sendRequestPair] = useSendRequestPairMutation();
  const [cancelRequestPair] = useCancelRequestPairMutation();
  const [removePair] = useRemovePairMutation();
  const [choicePair] = useChoicePairMutation();
  const [idRequestPair, setIdRequestPair] = useState<string | undefined>();
  const dispatch = useDispatch();

  const handleClickCircle = () => {
    if (props.liveState.role === 'host') {
      setIsAllowChoice(true);
    }
  };

  const handleClickAudient = (e: any) => {
    if (isAllowChoice) {
      setSelectedAudient(e.currentTarget.id);
    }
  };

  const handleCancelChoice = () => {
    if (selectedAudient) {
      setSelectedAudient('');
      setIsAllowChoice(false);
    } else {
      setIsAllowChoice(false);
    }
  };

  const handleChoice = async () => {
    if (selectedAudient) {
      const userPair = await choicePair({
        id: props.liveState.liveData?.radio?.id,
        userId: selectedAudient,
      }).unwrap();
      props.updateUserPair(userPair.pairUser);
      props.toggleVoiceGuestModal(false);
      setIsAllowChoice(false);
      setSelectedAudient('');
    }
  };
  const handleToggleAllowChoiceModal = () => {
    if (props.liveState.listPair.length > 0) {
      props.toggleRemoveUserPairModal(true);
    }
  };

  const callBackToggleModal = () => {
    setIsAllowChoice(false);
    props.toggleRemoveUserPairModal(false);
  };

  const callbackHandleAcceptRemoveAudient = async () => {
    await removePair({
      id: props.liveState.liveData?.radio?.id,
      userId: props.liveState.userPair?.id,
    }).unwrap();
    dispatch(actions.updateUserPair(undefined));
    props.toggleRemoveUserPairModal(false);
  };

  const handleSendRequestPair = async () => {
    if (!props.liveState.isSendRequestPair) {
      const data = await sendRequestPair({
        joinId: props.liveState.joinId,
      }).unwrap();
      if (data) {
        setIdRequestPair(data.id);
        props.handleChangeButtonRequest(true);
      }
    } else {
      if (idRequestPair) {
        await cancelRequestPair(idRequestPair).unwrap();
        setIdRequestPair('');
        props.handleChangeButtonRequest(false);
      }
    }
  };

  const handleToggleSettingPair = () => {
    dispatch(actions.toggleSettingPairModal(true));
  };

  const handleGuestWantEndPair = async () => {
    await removePair({
      id: props.liveState.liveData?.radio?.id,
      userId: props.liveState.userPair?.id,
    }).unwrap();
    dispatch(actions.updateUserPair(undefined));
    props.toggleVoiceGuestModal(false);
    props.handleChangeButtonRequest(false);
  };

  return (
    <Modal
      show={props.liveState.isShowVoiceGuestModal}
      centered
      backdrop="static"
      onHide={() => {
        props.toggleVoiceGuestModal(false);
        setIsAllowChoice(false);
      }}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="voiceguest-modal-body">
        {isAllowChoice ? (
          <>
            <h2 className="voiceguest-modal-body-text-allow-choice">
              ペア配信に招待する相手を選んでください
            </h2>
          </>
        ) : (
          <>
            <h2 className="voiceguest-modal-body-title">
              Voice Guest
              {props.liveState.role === 'host' ? (
                <span
                  onClick={handleToggleSettingPair}
                  className="voiceguest-modal-body-title-icon"
                >
                  <BsThreeDots />
                </span>
              ) : (
                <></>
              )}
            </h2>
            {props.liveState.userPair ? (
              <div className="voiceguest-modal-body-audient-out">
                <div className="audient-card">
                  <img
                    src={props.liveState.userPair.picture?.uri}
                    alt=""
                    className="audient-card-img"
                  />
                  <span className="audient-card-name">
                    {props.liveState.userPair.loginId}
                  </span>
                </div>
                {props.liveState.role === 'host' ? (
                  <div
                    className="voiceguest-modal-body-audient-out-btn"
                    onClick={handleToggleAllowChoiceModal}
                  >
                    <ImageCustom
                      className="voiceguest-modal-body-audient-out-btn-icon"
                      src={removePairImage}
                    />
                    <span className="voiceguest-modal-body-audient-out-btn-title">
                      ペア終了
                    </span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <>
                {props.liveState.isAcceptPair ? (
                  <>
                    <ImageCustom
                      className="voiceguest-modal-body-btn"
                      src={circleAcceptPair}
                      onClick={handleClickCircle}
                    />
                    <span className="voiceguest-modal-body-text">招待する</span>
                  </>
                ) : (
                  <>
                    <ImageCustom
                      className="voiceguest-modal-body-btn"
                      src={circleNotAcceptPair}
                    />
                    <span className="voiceguest-modal-body-text">
                      募集しない
                    </span>
                  </>
                )}
              </>
            )}
            <VoiceGuestRemoveModal
              toggleRemoveModal={props.liveState.isShowRemoveUserPairModal}
              audientGuest={props.liveState.userPair}
              callBackToggleModal={callBackToggleModal}
              callbackHandleAcceptRemoveAudient={
                callbackHandleAcceptRemoveAudient
              }
            />
            <VoicePairSettingModal {...props} />
          </>
        )}
      </Modal.Body>
      <div className="voiceguest-modal-footer">
        {props.liveState.role === 'host' ? (
          <>
            <h3 className="voiceguest-modal-footer-title">待機中ゲスト</h3>
            <div className="voiceguest-modal-footer-audient-list">
              {props.liveState.listPair.map((item, index) => (
                <div
                  className={
                    selectedAudient === item.user.id
                      ? 'audient-card selected'
                      : 'audient-card'
                  }
                  key={index}
                  onClick={handleClickAudient}
                  id={item.user.id}
                >
                  <img
                    src={item.user.picture.uri}
                    alt=""
                    className="audient-card-img"
                  />
                  <span className="audient-card-name">{item.user.loginId}</span>
                  <span className="audient-card-checked">
                    <BsCheck />
                  </span>
                </div>
              ))}
            </div>
          </>
        ) : (
          <></>
        )}
        {isAllowChoice && props.liveState.listPair.length > 0 ? (
          <div className="voiceguest-modal-footer-audient-btns">
            <button
              className="voiceguest-modal-footer-audient-btn-cancel"
              onClick={handleCancelChoice}
            >
              キャンセル
            </button>
            <button
              className={
                selectedAudient
                  ? 'voiceguest-modal-footer-audient-btn-choice selected'
                  : 'voiceguest-modal-footer-audient-btn-choice'
              }
              onClick={handleChoice}
            >
              招待する
            </button>
          </div>
        ) : (
          <></>
        )}
        {props.liveState.role === 'audience' ? (
          <>
            {props.liveState.userData?.id === props.liveState.userPair?.id ? (
              <div className="raise-hand-audient">
                <button
                  type="button"
                  onClick={handleGuestWantEndPair}
                  className={'raise-hand-audient-btn stop-pair'}
                >
                  ペア配信から退出
                </button>
              </div>
            ) : (
              <div className="raise-hand-audient">
                {props.liveState.isAcceptPair ? (
                  <button
                    type="button"
                    className={
                      props.liveState.isSendRequestPair
                        ? 'raise-hand-audient-btn raise'
                        : 'raise-hand-audient-btn'
                    }
                    onClick={handleSendRequestPair}
                  >
                    {props.liveState.isSendRequestPair
                      ? '参加希望をキャンセル'
                      : '参加希望する'}
                  </button>
                ) : (
                  <>
                    <button
                      type="button"
                      disabled
                      className={'raise-hand-audient-btn disable'}
                    >
                      参加希望する
                    </button>
                  </>
                )}
              </div>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  );
};
